import { Component, Input } from '@angular/core';
import { ResponsiveService } from '@frk/eds-components';
import { Ratings } from '@models';
import { parseNumber } from '@utils/text/number-utils';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-morning-star-details',
  templateUrl: './morning-star-details.component.html',
})
export class MorningStarDetailsComponent {
  @Input() ratingData: Ratings;
  isHandheld$: Observable<boolean>;
  styleboxArray = this.convertToArray('3');

  constructor(private responsiveService: ResponsiveService) {
    this.isHandheld$ = this.responsiveService.isHandheld$();
  }

  convertToArray(value: string): Array<any> {
    const numericValue = parseNumber(value);
    return numericValue ? new Array(numericValue) : [];
  }
}
